import moment from 'moment-timezone';

import { ICreateAbsenceRequestDTO } from 'src/api/dtos';
import { NotificationFlagsEnums } from 'src/shared/enums';

interface IAllowedToCancelProps {
  statusId: NotificationFlagsEnums;
  isPartialDay: boolean;
  startDate: string;
  endDate: string;
  allowCancelAfterApproved: boolean | undefined;
}

export const isUserAllowedToCancelAbsence = ({
  statusId,
  startDate,
  endDate,
  isPartialDay,
  allowCancelAfterApproved,
}: IAllowedToCancelProps): boolean => {
  if (statusId !== NotificationFlagsEnums.INITIAL && statusId !== NotificationFlagsEnums.ACCEPTED) {
    return false;
  }

  if (statusId === NotificationFlagsEnums.ACCEPTED && !allowCancelAfterApproved) {
    return false;
  }

  const today = moment();

  if (isPartialDay && moment(startDate).isBefore(today, 'day')) {
    return false;
  }

  return !moment(endDate).isBefore(today, 'day');
};

export const mapCreateAbsenceRequest = ({
  isPartialDay,
  absenceTypeId,
  startDate,
  endDate,
  startTime,
  endTime,
  notes,
}: Partial<ICreateAbsenceRequestDTO>): ICreateAbsenceRequestDTO => {
  return {
    isPartialDay: !!isPartialDay,
    absenceTypeId: absenceTypeId as number,
    startDate: startDate as string,
    endDate,
    startTime: startTime ? moment(startTime).format('H:mm:ss') : undefined,
    endTime: endTime ? moment(endTime).format('H:mm:ss') : undefined,
    notes: notes && notes.length > 0 ? notes : undefined,
  };
};

export const isAbsenceRequestInvalid = ({
  isPartialDay,
  absenceTypeId,
  notes,
  startDate,
  endDate,
  startTime,
  endTime,
}: Partial<ICreateAbsenceRequestDTO>): boolean => {
  if ((notes && notes.length > 1000) || !absenceTypeId?.toString().length || isNaN(Number(absenceTypeId))) {
    return true;
  }

  if (!isPartialDay) {
    return !startDate || !endDate;
  }

  return !startDate || !startTime || !endTime;
};
